import { createFileRoute } from '@tanstack/react-router'
import { tenantListSearchSchema } from '../../../../features/platform/search'
import { TenantsListPage } from '../../../../features/platform/tenants-list-page'

export const Route = createFileRoute('/platform/_console/tenants/')({
  validateSearch: tenantListSearchSchema,
  component: TenantsListPage,
})
